import DeleteProject from './DeleteProject';

type ConfirmModalSubComponents = {
  DeleteProject: typeof DeleteProject;
};

const ConfirmModal: ConfirmModalSubComponents = () => null;

ConfirmModal.DeleteProject = DeleteProject;

export default ConfirmModal;
